import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import {populateSearchParamWithDefaultSort} from 'search/getSortsOrDefault';
import SavedSearchesDropdown from 'search/saved-searches/SavedSearchesDropdown';
import {SavedSearchOptionsMenu} from 'search/saved-searches/SavedSearchOptionsMenu';
import {
  convertFromGraphqlSavedSearchParams,
  SAVED_SEARCH_SECTION_TO_SEARCH_TYPE,
  SavedSearch,
  savedSearchParamsAreEqual,
} from 'search/saved-searches/SavedSearchUtil';
import SaveSearchButton from 'search/saved-searches/SaveSearchButton';
import {SearchParams} from 'search/SearchConstants';

interface SavedSearchHeaderProps {
  searchSection: SearchSection;
  onSelectSavedSearch: (savedSearch?: SavedSearch) => Promise<void>;
  onSearch: (searchParams: SearchParams) => void;
  activeSavedSearch?: SavedSearch;
  searchParams: SearchParams;
  isExpanded: boolean;
}

export default function SavedSearchHeader(props: SavedSearchHeaderProps): JSX.Element {
  const searchParams = populateSearchParamWithDefaultSort(
    props.searchParams,
    SAVED_SEARCH_SECTION_TO_SEARCH_TYPE[props.searchSection]
  );

  const hasUnsavedChanges = Boolean(
    props.activeSavedSearch &&
      !savedSearchParamsAreEqual(
        convertFromGraphqlSavedSearchParams(props.activeSavedSearch.searchParams),
        searchParams
      )
  );
  return (
    <div className={css(styles.savedSearchHeader)}>
      <div className={css(styles.savedSearchHeaderContent)}>
        <SavedSearchesDropdown {...props} />
        {props.isExpanded && props.activeSavedSearch && (
          <span className={css(styles.savedSearchUpdateButton)}>
            <SaveSearchButton
              searchSection={props.searchSection}
              onSaved={props.onSelectSavedSearch}
              searchParams={searchParams}
              disabled={!(hasUnsavedChanges && props.activeSavedSearch.permissions.writable)}
              activeSavedSearch={props.activeSavedSearch}
            />
          </span>
        )}
        {props.activeSavedSearch && (
          <SavedSearchOptionsMenu
            searchSection={props.searchSection}
            onSaved={props.onSelectSavedSearch}
            onDeleted={() => {
              props.onSelectSavedSearch(undefined);
            }}
            onSearch={props.onSearch}
            targetSavedSearch={props.activeSavedSearch}
            searchParams={searchParams}
            hasUnsavedChanges={hasUnsavedChanges}
            hasUpdate={!props.isExpanded}
            hasReset={true}
          />
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  savedSearchUpdateButton: {
    marginLeft: 6,
    whiteSpace: 'nowrap',
  },
  savedSearchHeader: {
    display: 'inline-flex',
    alignItems: 'flex-end',
  },
  savedSearchHeaderContent: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});
